var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.previewUrl)?_c('iframe',{staticClass:"material-preview",attrs:{"src":'/viewer/#' + _vm.previewUrl,"allowfullscreen":"","webkitallowfullscreen":""}}):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4de66c0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/materials/MaterialPreview.vue
// module id = rifh
// module chunks = 0